import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowListItemIcon: Components<Theme>['MuiListItemIcon'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.mode === 'dark' ? theme.palette.onSurface.os300 : theme.palette.onSurface.os700,
      // match size of icon button
      minWidth: '44px',
      justifyContent: 'center',
      // icon itself
      '& .MuiSvgIcon-root': {
        // lower size
        fontSize: '18px',
      },
    }),
  },
};
